// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-settings-page {
  padding: 0;
  height: 100%;
}

.room-settings-section {
  margin-bottom: 32px;
}

.room-settings-section-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.room-settings-section-title {
  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #434343;
  margin: 0;
}

.room-settings-section-divider {
  height: 1px;
  background-color: #979797;
  width: 100%;
}

.room-settings-option-group {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.room-settings-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 0 16px;
  margin-bottom: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: transparent;
}

.room-settings-option:last-child {
  margin-bottom: 0;
}

.room-settings-option:hover:not(:has(input:disabled)) {
  background-color: transparent;
}

.room-settings-option:has(input:disabled) {
  opacity: 0.6;
  cursor: not-allowed;
}

.room-settings-option input[type="radio"] {
  margin-top: 2px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  accent-color: #DE4858;
}

.room-settings-option input[type="radio"]:disabled {
  cursor: not-allowed;
}

.room-settings-option-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.room-settings-option-label {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #2D2D2D;
  line-height: 1.2;
}

.room-settings-option-description {
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #6A6A6A;
  line-height: 1.2;
  letter-spacing: 0.3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/RoomSettings/SecurityPage.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2FAA2F;EAC3F,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB","sourcesContent":[".room-settings-page {\n  padding: 0;\n  height: 100%;\n}\n\n.room-settings-section {\n  margin-bottom: 32px;\n}\n\n.room-settings-section-header {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.room-settings-section-title {\n  font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  color: #434343;\n  margin: 0;\n}\n\n.room-settings-section-divider {\n  height: 1px;\n  background-color: #979797;\n  width: 100%;\n}\n\n.room-settings-option-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.room-settings-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 0 16px;\n  margin-bottom: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: transparent;\n}\n\n.room-settings-option:last-child {\n  margin-bottom: 0;\n}\n\n.room-settings-option:hover:not(:has(input:disabled)) {\n  background-color: transparent;\n}\n\n.room-settings-option:has(input:disabled) {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.room-settings-option input[type=\"radio\"] {\n  margin-top: 2px;\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  accent-color: #DE4858;\n}\n\n.room-settings-option input[type=\"radio\"]:disabled {\n  cursor: not-allowed;\n}\n\n.room-settings-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.room-settings-option-label {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 16px;\n  font-weight: 600;\n  color: #2D2D2D;\n  line-height: 1.2;\n}\n\n.room-settings-option-description {\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #6A6A6A;\n  line-height: 1.2;\n  letter-spacing: 0.3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
